import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "", once = true }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once, margin: "-70px" }}
        transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    >
        {children}
    </motion.div>
);

export const ChapterTag = ({ number, label, dark = false, center = false }) => (
    <div
        className={`flex items-center gap-3 mb-6 ${center ? "justify-center" : ""}`}
        data-testid={`chapter-${number}`}
    >
        <span className={`h-px w-10 ${dark ? "bg-[#CFC7B8]/40" : "bg-[#8C8275]/40"}`} />
        <span className={`font-sans text-[11px] font-medium tracking-[0.25em] uppercase ${dark ? "text-[#CFC7B8]" : "text-[#8C8275]"}`}>
            {label}
        </span>
        <span className={`h-px w-10 ${dark ? "bg-[#CFC7B8]/40" : "bg-[#8C8275]/40"}`} />
    </div>
);
